import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_perform_type'

export const dataPointDefinition = {
  retracedId: 'does_facility_perform_type',
  name: 'Does the facility perform any type of "hot work" (i.e. welding, soldering etc.)?',
  description:
    'Hot work: Includes welding and allied processes, grinding, heat treating, thawing pipe, and similar applications producing or using a spark, flame, or heat that it is sufficient to start a fire. Also includes laboratory operations that are open flame in nature.',
  meta: {
    slcpMeta: {
      key: 'hs-34',
      number: 'HS-WOR-25',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-34', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29350,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
